import React, { useState } from 'react'
import "./TechStack.css"
import Fade from 'react-reveal/Slide';
import Zoom from 'react-reveal/Zoom';


function TechStack() {

  const data = [
    { name: "Full Stack Developer" },
    { name: "Node js" },
    { name: "React js" },
    { name: "Mongodb" },
    { name: "Javascript" },
    { name: "Express js" },
    { name: "ejs Template" },
    { name: "Python" },
    { name: "UI/UX" },
    { name: "Flutter" },
    { name: "Java" },
    { name: "Data Science" },
  ]

  const colors = [
    "#FFA233",
    "#8DFF33",
    "#33FFDD",
    "#336BFF",
    "#6133FF",
    "#C433FF",
    "#FF33DD",
    "#FF337D",
    "#FFF333",
    "#33FFAC",
    "#33DAFF",
    "#8A33FF",
  ];


  const [showMoreTechStack, setShowMoreTechStack] = useState(9)

  const loadMore = () => {
    setShowMoreTechStack((prev) => prev + 3)
  }


  return (
    <div className="container" id='techStack'>
      <div className="section-titel">
        <h5>Tech Stack</h5>
        <span className='line1'></span>
      </div>

      <div className="con">
        <div className="row">

          {data.slice(0, showMoreTechStack).map((item, index) => {

            return <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 " key={index}>
              <Fade right>
                <div className={index === 0 ? "TechStack-content-marked TechStack-content" : "TechStack-content"}>
                  <span className='tech-number' style={{ backgroundColor: colors[index] }}>
                    {index + 1}
                  </span>
                  <p>{item.name}</p>
                </div>
              </Fade>
            </div>

          })}


        </div>
      </div>

      {/* if the data is reach end hide the button */}
    
      {showMoreTechStack >= data.length ? null : (
          <Zoom>
          <span className='load-more-tech-stack' onClick={loadMore}>
            Load More
          </span>
          </Zoom>
      )}
      

    </div>
  )
}

export default TechStack